import { getUrl, usePlatformGet } from '@reapitform/hooks'
import { useMemo } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { AgreementStatusSummaryResponse } from '../types/agreements'

const path: string = '/api/Document/StatusSummary'

export const getAgreementStatusSummaryQueryKey: () => string = getUrl(path)

export const useAgreementStatusSummary = () => {
  const queryClient = useQueryClient()

  const [result, loading, errorString] = usePlatformGet<AgreementStatusSummaryResponse>({
    path,
    retry: false,
  })

  const queryKey = useMemo(getAgreementStatusSummaryQueryKey, [path])

  const data = result ?? null

  const updateCacheData = (
    data:
      | AgreementStatusSummaryResponse
      | ((preData: AgreementStatusSummaryResponse) => AgreementStatusSummaryResponse),
  ) => {
    if (!queryClient) return

    queryClient.setQueryData([queryKey], (prevData: AgreementStatusSummaryResponse) => {
      let newValue = data
      if (typeof data === 'function') newValue = data(prevData)

      return { ...prevData, ...newValue }
    })

    queryClient.invalidateQueries({ queryKey: [queryKey] })
  }

  return { data, loading, errorString, updateCacheData }
}
